module.exports = __webpack_public_path__ + "img/product3_l.4e865df8.jpg";